import React, { useState, useRef } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import ModalContainer from '../../containers/ModalContainer';
import { ButtonIconBackground } from '../../../inputs/buttons/ButtonIconBackground';

// Types
import { ModalProps } from './types';
import AccidentSketch from '../../../inputs/AccidentSketch';
import { ButtonsContainer, CanvasPreview } from './styles';
import { ImperativeRefSketch } from '../../../inputs/AccidentSketch/types';

// Constants
import { formAccidentNaming } from '../../../forms/AddBasicInfoAccidentForm/constants';

export const AddSketchModal = ({
  onClickClose,
  onAddSketch,
  ...props
}: ModalProps): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation('common');
  const [sketch, setSketch] = useState<string | null>(null);
  const sketchRef = useRef<ImperativeRefSketch>(null);

  const handleSaveDraw = () => {
    const sketchFromSessionStorage = sessionStorage.getItem(
      formAccidentNaming.IMAGE_CANVAS
    );
    setSketch(sketchFromSessionStorage);
  };

  const handleCancel = () => {
    setSketch(null);
    setTimeout(() => {
      sketchRef.current?.getSvg();
    }, 1);
  };

  return (
    <ModalContainer
      width={140}
      onClickClose={onClickClose}
      fill={theme.colors.black}
      title={t('addSketch.title')}
      {...props}
    >
      {!sketch ? (
        <AccidentSketch ref={sketchRef} onSaveDraw={handleSaveDraw} />
      ) : (
        <>
          <CanvasPreview src={sketch} alt={t('addSketch.previewAlt')} />
          <ButtonsContainer>
            <ButtonIconBackground
              type="button"
              onClick={onAddSketch}
              variant="check"
            />
            <ButtonIconBackground
              type="button"
              onClick={handleCancel}
              variant="edit"
            />
          </ButtonsContainer>
        </>
      )}
    </ModalContainer>
  );
};
